import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { EntityState } from '@api/models/enums/EntityState';
import { QuestionnaireDto } from '@api/models/questionnaire/QuestionnaireDto';
import { questionnaireService } from '@api/services/services';

export interface QuestionnaireListFilter extends ListFilter {
  state?: EntityState;
}

export type QuestionnaireListState = ListType<QuestionnaireDto, QuestionnaireListFilter>;

const initialState: QuestionnaireListState = {
  state: FetchState.None,
  data: undefined,
  query: {
    state: EntityState.Active,
    sortBy: 'name',
    sortDesc: false,
  },
};

export const questionnaireListSlice = listSlice({
  name: 'questionnaireList',
  initialState,
});

export const selectQuestionnaireList = (state: RootState) => state.questionnaireList;
export const questionnaireListActions = questionnaireListSlice.actions;

export const getQuestionnaireList = (cancelToken: CancelToken) => (dispatch: AppDispatch) => {
  const storeState = store.getState();
  const data = selectQuestionnaireList(storeState);

  const handleGetData = (size: number) => {
    return questionnaireService.query(
      {
        q: data.query.q,
        state: data.query.state,
        page: data.query.page,
        size: size,
        sort: getListSort(data),
      },
      { cancelToken: cancelToken },
    );
  };

  getList({
    dispatch,
    cancelToken,
    state: data.state,
    actions: questionnaireListActions,
    getData: handleGetData,
  });
};
